import { Loader2, Eye, EyeOff } from 'lucide-react';
import { useRef, useEffect, useState } from 'react';

export function Button({ children, variant, loading, className = '', ...props }) {
  const cls = ['btn', variant, className].filter(Boolean).join(' ');
  return (
    <button className={cls} disabled={loading || props.disabled} {...props}>
      {loading && <Loader2 size={16} className="spin" style={{ animation: 'spin 1s linear infinite' }} />}
      {children}
    </button>
  );
}

export function Field({ label, error, hint, children }) {
  return (
    <label className="field">
      {label && <span style={{ display: 'block', fontWeight: 600, marginBottom: 5, fontSize: 13 }}>{label}</span>}
      {children}
      {error && <span className="error">{error}</span>}
      {hint && !error && <span className="hint">{hint}</span>}
    </label>
  );
}

export function Input(props) {
  return <input className="input" {...props} />;
}

// Input de senha com botao de mostrar/ocultar
export function PasswordInput(props) {
  const [show, setShow] = useState(false);
  return (
    <span className="input-affix">
      <input className="input" type={show ? 'text' : 'password'} {...props} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1} aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}>
        {show ? <EyeOff size={17} /> : <Eye size={17} />}
      </button>
    </span>
  );
}

export function Textarea(props) {
  return <textarea className="textarea" {...props} />;
}

// Textarea que cresce automaticamente conforme o conteúdo (sem cortar/scroll)
export function AutoTextarea({ value, minHeight = 90, className = '', ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = Math.max(minHeight, el.scrollHeight) + 'px';
    }
  }, [value, minHeight]);
  return <textarea ref={ref} className={`textarea ${className}`} style={{ overflow: 'hidden' }} value={value} {...props} />;
}

export function Select({ children, ...props }) {
  return <select className="input" {...props}>{children}</select>;
}

const STATUS_BADGE = {
  draft: ['gray', 'Rascunho'],
  approved: ['blue', 'Aprovado'],
  scheduled: ['yellow', 'Agendado'],
  published: ['green', 'Publicado'],
  failed: ['red', 'Falhou']
};

export function StatusBadge({ status }) {
  const [color, label] = STATUS_BADGE[status] || ['gray', status];
  return <span className={`badge ${color}`}>{label}</span>;
}
